export const Participanttype = [
    { name: 'DOCTOR', code: 'DOCTOR' },
    { name: 'TECHNICIAN', code: 'TECHNICIAN' },
    { name: 'OTHER', code: 'OTHER' },
];